"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMouseInput = void 0;
const ValueObjects_1 = require("../ValueObjects");
function makeMouseInput() {
    return new MouseInputImp();
}
exports.makeMouseInput = makeMouseInput;
class MouseInputImp {
    constructor() {
        this.controllers = [];
        this.maxClickMovement = 5; // pixels
        this.isPressed = false;
        this._eventElement = undefined;
        this.setEventElement = (eventElement) => {
            if (this._eventElement)
                this.clearInputElement();
            eventElement.addEventListener("mousedown", this.onMouseDown, false);
            eventElement.addEventListener("mouseup", this.onMouseUp, false);
            eventElement.addEventListener("mousemove", this.onMouseMove, false);
            eventElement.addEventListener("mouseout", this.onMouseOut, false);
            eventElement.addEventListener("wheel", this.onWheel, false);
            this._eventElement = eventElement;
        };
        this.clearInputElement = () => {
            if (!this._eventElement)
                return;
            this._eventElement.removeEventListener("mousedown", this.onMouseDown);
            this._eventElement.removeEventListener("mouseup", this.onMouseUp);
            this._eventElement.removeEventListener("mousemove", this.onMouseMove);
            this._eventElement.removeEventListener("mouseout", this.onMouseOut);
            this._eventElement.removeEventListener("wheel", this.onWheel);
            this._eventElement = undefined;
        };
        this.registerController = (controller) => {
            this.controllers.push(controller);
        };
        this.removeController = (controller) => {
            const index = this.controllers.indexOf(controller);
            if (index >= 0) {
                this.controllers.splice(index, 1);
            }
        };
        this.onMouseDown = (e) => {
            const inputEvt = this.makeMouseInputEvent(e);
            this.controllers.forEach((c) => {
                if (c.onDown) {
                    c.onDown(inputEvt);
                }
            });
            this.isPressed = true;
            this.pressEvent = e;
        };
        this.onMouseUp = (e) => {
            const inputEvt = this.makeMouseInputEvent(e);
            this.controllers.forEach((c) => {
                if (c.onUp) {
                    c.onUp(inputEvt);
                }
            });
            this.isPressed = false;
            if (!this.pressEvent)
                return;
            const deltaX = this.pressEvent.screenX - e.screenX;
            const deltaY = this.pressEvent.screenY - e.screenY;
            const delta = new ValueObjects_1.Vector2(deltaX, deltaY);
            if (delta.magnitued < this.maxClickMovement) {
                this.controllers.forEach((c) => {
                    if (c.onClick) {
                        c.onClick(inputEvt);
                    }
                });
            }
            this.pressEvent = undefined;
        };
        this.onMouseMove = (e) => {
            const inputEvt = this.makeMouseInputEvent(e);
            this.controllers.forEach((c) => {
                if (c.onMove) {
                    c.onMove(inputEvt);
                }
            });
            if (!this.pressEvent)
                return;
            const deltaX = this.pressEvent.screenX - e.screenX;
            const deltaY = this.pressEvent.screenY - e.screenY;
            const delta = new ValueObjects_1.Vector2(deltaX, deltaY);
            if (delta.magnitued > this.maxClickMovement) {
                this.pressEvent = undefined;
            }
        };
        this.onMouseOut = (e) => {
            if (!this.isPressed)
                return;
            const inputEvt = this.makeMouseInputEvent(e);
            this.controllers.forEach((c) => {
                if (c.onUp) {
                    c.onUp(inputEvt);
                }
            });
            this.pressEvent = undefined;
            this.isPressed = false;
        };
        this.onWheel = (e) => {
            e.preventDefault();
            const inputEvt = this.makeMouseInputEvent(e);
            this.controllers.forEach((c) => {
                if (c.onWheel) {
                    c.onWheel(inputEvt);
                }
            });
        };
    }
    get eventElement() {
        return this._eventElement;
    }
    makeMouseInputEvent(event) {
        const px = event.offsetX;
        const py = event.offsetY;
        const button = event.button;
        return {
            position: new ValueObjects_1.Vector2(px, py),
            button,
            event,
        };
    }
}
